import { render } from "./BusinessInvoiceCustomersModal.vue?vue&type=template&id=62bee5b1&scoped=true&ts=true"
import script from "./BusinessInvoiceCustomersModal.vue?vue&type=script&lang=ts"
export * from "./BusinessInvoiceCustomersModal.vue?vue&type=script&lang=ts"

import "./BusinessInvoiceCustomersModal.vue?vue&type=style&index=0&id=62bee5b1&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution/ClientApp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62bee5b1"]])

export default __exports__